<template>
  <div>
    <v-container>
      <v-layout row>
        <h2 v-if="!editing">{{ studentName }}</h2>
          <div v-if="editing">
            <v-text-field v-model="student.nameFirst" label="First Name"></v-text-field>
          </div>
          &nbsp;
          <div v-if="editing">
            <v-text-field v-model="student.nameLast" label="Last Name"></v-text-field>
          </div>
        <v-flex>
          <v-chip
            class="cursor-chip"
            v-if="student.active"
            @click="toggleStudentStatus(false)"
            disabled
            small
            color="success"
            text-color="white"
          >Active</v-chip>
          <v-chip
            class="cursor-chip"
            v-else
            @click="toggleStudentStatus(true)"
            disabled
            small
            color="error"
            text-color="white"
          >Disabled</v-chip>
        </v-flex>
        <v-btn small @click.stop="membershipFormDialog = true">Membership</v-btn>
        <v-btn small @click.stop="testFormDialog = true">Test Form</v-btn>
        <div v-if="!editing">
          <v-btn small @click="editing=true">Edit</v-btn>
        </div>
        <div v-else>
          <v-btn small color="success" @click="updateStudent">Save</v-btn>
          <v-btn small color="error" @click="cancelEditing">Cancel</v-btn>
        </div>
      </v-layout>
    </v-container>
    <v-container grid-list-lg>
      <v-form class="compact-form">
        <v-layout>
          <v-flex>
            <v-card height="100%">
              <v-card-title>
                <h2>Info</h2>
              </v-card-title>
              <v-card-text>
                <v-layout column>
                  <v-flex v-if="!editing">
                    <strong>Email:</strong>
                    {{ student.email }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field v-model="student.email" label="Email"></v-text-field>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>Phone:</strong>
                    {{ student.phone }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="student.phone"
                      label="Phone"
                      mask="(###)###-####"
                      :return-masked-value="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>Cell Phone:</strong>
                    {{ student.cellPhone }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="student.cellPhone"
                      label="Cell Phone"
                      mask="(###)###-####"
                      :return-masked-value="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>Emergency Phone:</strong>
                    {{ student.emergencyPhone }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="student.emergencyPhone"
                      label="Emergency Phone"
                      mask="(###)###-####"
                      :return-masked-value="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>Gender:</strong>
                    {{ student.gender }}
                  </v-flex>
                  <v-flex v-else>
                    <v-select v-model="student.gender" :items="genders" label="Gender"></v-select>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>DOB:</strong>
                    {{ student.dob }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="student.dob"
                      label="DOB"
                      mask="##/##/####"
                      :return-masked-value="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>Age:</strong>
                    {{ age }}
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card height="100%">
              <v-card-title>
                <h2>ITF</h2>
              </v-card-title>
              <v-card-text>
                <v-layout column>
                  <v-flex v-if="!editing">
                    <strong>ITF Number:</strong>
                    {{ student.ITFnumber }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field v-model="student.ITFnumber" label="ITF Number"></v-text-field>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>Rank:</strong>
                    {{ student.rank }}
                  </v-flex>
                  <v-flex v-else>
                    <v-select v-model="student.rank" :items="ranks" label="Rank"></v-select>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>Test Number:</strong>
                    {{ student.testNumber }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field v-model="student.testNumber" label="Test Number"></v-text-field>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>Belt Size:</strong>
                    {{ student.beltSize }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field v-model="student.beltSize" label="Belt Size"></v-text-field>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>Start Date:</strong>
                    {{ student.startDate }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="student.startDate"
                      label="Start Date"
                      mask="##/##/####"
                      :return-masked-value="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>Last Test:</strong>
                    {{ student.lastTest }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="student.lastTest"
                      label="Last Test"
                      mask="##/##/####"
                      :return-masked-value="true"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card height="100%">
              <v-card-title>
                <h2>Address</h2>
              </v-card-title>
              <v-card-text>
                <v-layout column>
                  <v-flex v-if="!editing">
                    <strong>Address:</strong>
                    {{ student.address }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field v-model="student.address" label="Address"></v-text-field>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>City:</strong>
                    {{ student.city }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field v-model="student.city" label="City"></v-text-field>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>State:</strong>
                    {{ student.state }}
                  </v-flex>
                  <v-flex v-else>
                    <v-select v-model="student.state" :items="states" label="State"></v-select>
                  </v-flex>
                  <v-flex v-if="!editing">
                    <strong>Zip:</strong>
                    {{ student.zip }}
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field v-model="student.zip" label="Zipcode"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>

    <v-dialog v-model="testFormDialog" max-width="300px">
      <v-card>
        <v-card-title class="grey lighten-2">
          <h3>Testing Form Options</h3>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout column>
              <v-flex>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      label="Date of Test"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="testDate" @input="dateMenu = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex>
                <v-radio-group v-model="testFormType">
                  <v-radio label="Gup Form" value="gup"></v-radio>
                  <v-radio label="Pretest Form" value="pretest"></v-radio>
                  <v-radio label="Dan Form" value="dan"></v-radio>
                  <v-radio label="Recertification Form" value="recert"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" small @click.stop="generateTestForm">Generate</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="membershipFormDialog" max-width="300px">
      <v-card>
        <v-card-title class="grey lighten-2">
          <h3>Membership Form Options</h3>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout column>
              <v-flex>
                <v-radio-group v-model="phoneType" label="Preferred Phone Number">
                  <v-radio label="Phone" value="phone"></v-radio>
                  <v-radio label="Cell Phone" value="cell"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-divider></v-divider>
              <v-flex>
                <v-radio-group v-model="membershipFormType">
                  <v-radio label="Gup Membership" value="gup"></v-radio>
                  <v-radio label="Dan Membership" value="dan"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" small @click.stop="generateMembershipForm">Generate</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import testForms from "../../../scripts/testForms.js";
import membershipForms from "../../../scripts/membershipForms.js";
import { mapGetters } from "vuex";

export default {
  props: {
    initialStudent: {}
  },
  data() {
    return {
      testFormDialog: false,
      membershipFormDialog: false,
      dateMenu: false,
      testDate: new Date().toISOString().substr(0, 10),
      testDateFormatted: this.formatDate(
        new Date().toISOString().substr(0, 10)
      ),
      testFormType: "gup",
      membershipFormType: "gup",
      phoneType: "phone",
      editing: false,
      student: Object.assign({}, this.initialStudent)
    };
  },
  computed: {
    ...mapGetters({
      genders: "getGenders",
      ranks: "getRanks",
      states: "getStates"
    }),
    computedDateFormatted() {
      return this.formatDate(this.testDate);
    },
    studentName() {
      return this.student.nameFirst + " " + this.student.nameLast;
    },
    age() {
      var today = new Date();
      var birthDate = new Date(this.student.dob);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    cancelEditing() {
      this.$confirm(
        "Are you sure you want to cancel. All changes will be lost."
      ).then(res => {
        if (res) {
          // reset the editable student to the original data
          this.student = null;
          this.student = Object.assign({}, this.initialStudent);
          this.editing = false;
        }
      });
    },
    updateStudent() {
      this.$confirm(
        "Are you sure you want to update this student's information?"
      ).then(res => {
        if (res) {
          this.$store.dispatch("updateStudent", this.student);
          this.editing = false;
        }
      });
    },
    toggleStudentStatus(status) {
      if (this.student.active) {
        this.$confirm("Are you sure you want to disable this student?").then(
          res => {
            if (res) {
              this.$store.dispatch("toggleStudentStatus", {
                student: this.student,
                status: status
              });
            }
          }
        );
      } else {
        this.$confirm("Are you sure you want to enable this student?").then(
          res => {
            if (res) {
              this.$store.dispatch("toggleStudentStatus", {
                student: this.student,
                status: status
              });
            }
          }
        );
      }
    },
    generateTestForm() {
      switch (this.testFormType) {
        case "gup":
          testForms.gupTestForm(
            this.student,
            this.age,
            this.computedDateFormatted
          );
          break;
        case "pretest":
          testForms.pretestTestForm(
            this.student,
            this.age,
            this.computedDateFormatted
          );
          break;
        case "dan":
          testForms.danTestForm(
            this.student,
            this.age,
            this.computedDateFormatted
          );
          break;
        case "recert":
          testForms.danRecertForm(
            this.student,
            this.age,
            this.computedDateFormatted
          );
          break;
        default:
          break;
      }

      this.testFormDialog = false;
    },
    generateMembershipForm() {
      switch (this.membershipFormType) {
        case "gup":
          membershipForms.gupMembership(this.student, this.phoneType);
          break;
        case "dan":
          membershipForms.danMembership(this.student, this.phoneType);
          break;
        default:
          break;
      }

      this.membershipFormDialog = false;
    }
  }
};
</script>

<style>
</style>